import React from "react";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import { TextCaption } from "fonts/Caption";

import { classNames } from "helpers/string";
import { LabelFont } from "../fonts";
import ITextareaProps from "./types";

export const TextareaVW = ({
  error,
  placeholder,
  disabled,
  autoFocus,
  value = "",
  onChange,
  label,
  name,
  readOnly,
  onKeyDown
}: ITextareaProps) => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        <label htmlFor={name}>
          <LabelFont>{label}</LabelFont>
        </label>
        <textarea
          className={classNames(styles, { error })}
          onChange={onChange}
          onKeyDown={onKeyDown}
          {...{
            disabled,
            value,
            placeholder,
            autoFocus,
            name,
            readOnly
          }}
        />
      </div>
      {error && (
        <React.Fragment>
          <Spacing pt="5xs" />
          <TextCaption className={styles.redColor}>{error}</TextCaption>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
